/* eslint-disable require-jsdoc */
import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { Book as BookIcon } from '@mui/icons-material';
import Button from '../components/Button.js';
import { colors } from '../theme/index.js';
import i18n from '../localization/i18n.js';
import tokens from '../localization/tokens.js';

/**
 * Download the employee booklet
 * @param employee
 * @private
 */
const _downloadManualBooklet = employee => {
  const url = `https://d6hvupc5g7lnm.cloudfront.net/member-booklets/${employee.meta.accountID}/${employee.meta.classID}.pdf`;
  const link = document.createElement('a');
  const companyName = employee.meta.company.split(' ').join('_');
  link.href = url;
  link.setAttribute('download', `${companyName}_${employee.meta.cert}.pdf`);
  link.setAttribute('target', "_blank");
  document.body.appendChild(link);
  link.click();
};
const BookletDownload = ({
  employee,
  isListItem = false,
  whitelabel,
  getAdminPdf,
  loading,
  customStyle = {}
}) => {
  const [bookletGenerated, setBookletGenerated] = useState(false);
  const downloadAutoBooklet = () => {
    getAdminPdf("MemberBooklet", "Booklet.pdf", {
      userID: employee.meta.userID
    }, true);
  };

  // if the member has no manual booklet and is not set to use the auto booklets then return nothing
  if (!employee.meta.hasBooklet && !employee.meta.useAutoBooklet) {
    return null;
  }

  // if the member is set to the use the auto booklets then we need to provide a way to generate them
  if (employee.meta.useAutoBooklet) {
    if (!bookletGenerated) {
      if (isListItem) {
        return /*#__PURE__*/React.createElement(ListItem, {
          button: true,
          onClick: () => {
            setBookletGenerated(true);
            downloadAutoBooklet();
          },
          style: {
            padding: "15px 25px"
          }
        }, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
          style: {
            backgroundColor: whitelabel.lightColor || colors.lightBlue,
            color: whitelabel.primaryColor || colors.skyBlue
          }
        }, /*#__PURE__*/React.createElement(BookIcon, null))), /*#__PURE__*/React.createElement(ListItemText, {
          primary: i18n.t(tokens.buttons.generateEmployeeBooklet)
        }));
      }
      return /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        customStyle: {
          height: 50,
          width: 260,
          textTransform: "capitalize",
          fontSize: 16,
          alignSelf: 'flex-end',
          marginBottom: "20px"
        },
        onClick: () => setBookletGenerated(true)
      }, i18n.t(tokens.buttons.generateEmployeeBooklet));
    }
    return /*#__PURE__*/React.createElement("div", {
      style: {
        textDecoration: 'none'
      }
    }, loading ? isListItem ? /*#__PURE__*/React.createElement(ListItem, {
      style: {
        padding: "15px 25px"
      }
    }, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
      style: {
        backgroundColor: whitelabel.lightColor || colors.lightBlue,
        color: whitelabel.primaryColor || colors.skyBlue
      }
    }, /*#__PURE__*/React.createElement(BookIcon, null))), /*#__PURE__*/React.createElement(ListItemText, {
      primary: i18n.t(tokens.buttons.generating)
    })) : /*#__PURE__*/React.createElement(Button, {
      disabled: true,
      color: "primary",
      customStyle: {
        height: 50,
        width: 180,
        textTransform: "capitalize",
        fontSize: 16,
        alignSelf: 'flex-end',
        ...customStyle
      }
    }, i18n.t(tokens.buttons.generating)) : isListItem ? /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      style: {
        padding: "15px 25px"
      },
      onClick: () => {
        setBookletGenerated(true);
        downloadAutoBooklet();
      }
    }, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
      style: {
        backgroundColor: whitelabel.lightColor || colors.lightBlue,
        color: whitelabel.primaryColor || colors.skyBlue
      }
    }, /*#__PURE__*/React.createElement(BookIcon, null))), /*#__PURE__*/React.createElement(ListItemText, {
      primary: i18n.t(tokens.buttons.downloadEmployeeBooklet)
    })) : /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      customStyle: {
        height: 50,
        width: 260,
        textTransform: "capitalize",
        fontSize: 16,
        alignSelf: 'flex-end',
        ...customStyle
      }
    }, i18n.t(tokens.buttons.downloadEmployeeBooklet)));
  }
  if (isListItem) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      onClick: () => _downloadManualBooklet(employee),
      style: {
        padding: "15px 25px"
      }
    }, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
      style: {
        backgroundColor: whitelabel.lightColor || colors.lightBlue,
        color: whitelabel.primaryColor || colors.skyBlue
      }
    }, /*#__PURE__*/React.createElement(BookIcon, null))), /*#__PURE__*/React.createElement(ListItemText, {
      primary: i18n.t(tokens.buttons.downloadEmployeeBooklet)
    }));
  }

  // member has booklet but not auto so load the manual booklet
  return /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    customStyle: {
      height: 50,
      width: 260,
      textTransform: "capitalize",
      fontSize: 16,
      alignSelf: 'flex-end',
      marginBottom: "20px"
    },
    onClick: () => _downloadManualBooklet(employee)
  }, i18n.t(tokens.buttons.downloadEmployeeBooklet));
};
export default BookletDownload;